import { MedicareConsent } from '@/consent/medicare/domain/MedicareConsent';
import { MedicareConsentRepository } from '@/consent/medicare/domain/MedicareConsentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { ServicesApiResponse } from '@hfc/ui-core';
import { UUID } from '@hfc/common/src/types/UUID';

export class SaveAndExitConsentUseCase implements UseCase<[UUID, string|null, number|null, MedicareConsent], ServicesApiResponse<MedicareConsent>> {

  private repository: MedicareConsentRepository;

  public constructor (repository: MedicareConsentRepository) {
    this.repository = repository;
  }

  public async run (params: [UUID, string|null, number|null, MedicareConsent]): Promise<ServicesApiResponse<MedicareConsent>> {
    const [uuid, email, phone, medicareConsent] = params;

    return await this.repository.saveAndExit(uuid, email, phone, medicareConsent);
  }

}
